import { FC } from 'react';

import Button from '@/components/elements/Button/BaseButton';

import {
  Balance,
  BalanceContainer,
  BalanceInfo,
  ToretaIcon,
  WalletWrapper,
  YenIcon,
} from './style';

export enum BalanceType {
  Toreta = 'toreta',
  Cash = 'cash',
}

interface WalletInfoProps {
  balanceType: BalanceType;
  balance: number;
  handleClick: () => void;
}

const WalletInfo: FC<WalletInfoProps> = ({
  balanceType,
  balance,
  handleClick,
}) => {
  return (
    <WalletWrapper>
      <BalanceInfo>
        <BalanceContainer balanceType={balanceType} data-testid="text">
          {balanceType === BalanceType.Cash && (
            <>
              <YenIcon />
              入金/払戻金 残高
            </>
          )}
          {balanceType === BalanceType.Toreta && (
            <>
              <ToretaIcon />
              toreta+ 残高
            </>
          )}
        </BalanceContainer>
        <Balance data-testid={`${balanceType}-balance`}>
          <span>{balance.toLocaleString()}</span>円
          {balanceType === BalanceType.Toreta && '分'}
        </Balance>
      </BalanceInfo>
      <Button
        bgColor={balanceType === BalanceType.Cash ? 'primary' : 'yellow'}
        size="s"
        fontWeight="bold"
        onClick={() => handleClick()}
      >
        {balanceType === BalanceType.Cash && <>入金・精算</>}
        {balanceType === BalanceType.Toreta && <>チャージ</>}
      </Button>
    </WalletWrapper>
  );
};

export default WalletInfo;
